const Theme = {
  body_background_color: 'rgb(77, 95, 86)',

  header_background_url: 'mdlg/mdlg.png',
  logo_hidden: true,
  header_height: 500,

  button_color: 'rgb(255, 72, 0)',
  button_radius: 15,

  title_font: 'WorkSans',
  title_weight: 700,

  subtitle_font: 'WorkSans',
  subtitle_weight: 700,

  text_font: 'WorkSans',
  text_weight: 400,
}

export default Theme